import { useEffect, useState } from 'react';

export function useLocalStorage<T>(key: string, defaultValue: T) {
  const [value, setValue] = useState(() => {
    let currentValue;

    try {
      currentValue = JSON.parse(localStorage.getItem(key) || String(defaultValue));
    } catch (error) {
      currentValue = defaultValue;
    }

    return currentValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value, key]);

  return [value, setValue] as const;
}

export function findLanguageCode(language: any) {
  switch (language) {
    case 'French':
    case 'Français':
      return 'fr';
    case 'English':
      return 'en';
    default:
      return 'en';
  }
}

export function findLanguageName(language: any) {
  switch (language) {
    case 'fr':
      // return 'French';
      return 'Français';
    case 'en':
      return 'English';
    default:
      return 'English';
  }
}
